import {
  Box,
  Feedback,
  Flex,
  FormErrorTypes,
  WorkingHoursInput,
} from 'dash-ui';
import { WeekDays } from 'dash-common';
import moment from 'moment';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { FormFields } from 'containers/properties/AdvancedPropertyDetails/AdvancedPropertyDetails.constants';
import { IWorkingHoursProps } from './SalesWorkingHours.interfaces';

const StyledWrapper = styled(Flex)`
  max-width: 966px;
`;

const SalesWorkingHours = ({
  setWorkingHours,
  setWorkingHoursError,
  formErrors,
  formState,
  disabled,
}: IWorkingHoursProps) => {
  const { t } = useTranslation(['forms', 'common']);
  const [errorFields, setErrorFields] = useState<string[]>([]);
  const [fieldToReset, setFieldToReset] = useState<{
    field: string;
    isReset: boolean;
  }>({
    field: '',
    isReset: false,
  });

  useEffect(() => {
    // FIXME: re-creating context functions everytime state change. Use useCallback
    if (fieldToReset.isReset) {
      setWorkingHours({
        ...formState.workingHours,
        [fieldToReset.field]: undefined,
      });
    } else {
      // set default hours range
      const [defaultFrom, defaultTo] = [
        moment()
          .set({ hour: 8, minute: 0, second: 0, millisecond: 0 })
          .toISOString(),
        moment()
          .set({ hour: 17, minute: 0, second: 0, millisecond: 0 })
          .toISOString(),
      ];

      setWorkingHours({
        ...formState.workingHours,
        [fieldToReset.field]: {
          from: defaultFrom,
          to: defaultTo,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fieldToReset]);

  const onChange = (key: string) => (value: { from?: string; to?: string }) => {
    if (moment(value.from).isAfter(value.to)) {
      setErrorFields((prev) => [...prev, key]);

      return setWorkingHoursError({
        type: FormErrorTypes.Invalid,
        message: t('forms:messages.workingHoursValidateMessage'),
      });
    }
    setWorkingHoursError(null);
    setErrorFields(errorFields.filter((item) => item !== key));
    setWorkingHours({ ...formState.workingHours, [key]: value });
  };

  return (
    <StyledWrapper flexWrap="wrap" justifyContent="space-between" px={6} mt={8}>
      {Object.values(WeekDays).map((day) => {
        const date = formState.workingHours && formState.workingHours[day];

        return (
          <Box w="100%" key={day} mb={9}>
            <WorkingHoursInput
              disabled={disabled}
              label={t(`common:labels.weekDays.${day}`)
                .slice(0, day === WeekDays.Tuesday ? 4 : 3)
                .toUpperCase()}
              onSwitch={(checked) =>
                setFieldToReset({ field: day, isReset: !checked })
              }
              onChange={onChange(day)}
              defaultValue={date}
            />

            {errorFields.includes(day) && (
              <Feedback $errorType={formErrors[FormFields.Working_Hours]?.type}>
                {formErrors[FormFields.Working_Hours]?.message}
              </Feedback>
            )}
          </Box>
        );
      })}
    </StyledWrapper>
  );
};

export default SalesWorkingHours;
